var v1="<div href=\"javascript:void(0)\" ng-click=\"showYardage()\" class=\"row text-green text-heading no-margin\"><div class=\"col-10 no-padding\"><left>{{ :: '_CLUB_PAGE.YARDAGE' | translate }}</left></div><div class=\"col-2 no-padding\"><a ng-class=\"{active:isShowYardage}\" class=\"btn-show-detail no-margin\"><img src=\"" + require("../../../../images/clubs/down_green.png") + "\"/></a></div></div><div ng-repeat=\"card in scoreCardCtrl.scorecards\" club-score-card=\"\" course=\"card.yardage\" course-name=\"card.course.name\" show=\"isShowYardage\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-scorecard/club-scorecard.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/club/club-scorecard/club-scorecard.jade
// module id = 667
// module chunks = 0